import { createSignal } from '@rwwa/rwwa-rx-state-machine'
import type { OverlayOpenProps } from '@core/Components/Overlay/types'

export const OverlayOpen = createSignal<OverlayOpenProps>('OverlayOpen')
export const OverlayClose = createSignal('OverlayClose')
export const OverlayReset = createSignal('OverlayReset')
